export interface Options {
	storesPassedThreshold?: number;
	totalStoresObserved?: number;
}

const totalStoresPassedObservationThresholdPercentage = ({
	storesPassedThreshold,
	totalStoresObserved
}: Options) => {
	if (storesPassedThreshold === undefined || totalStoresObserved === undefined)
		return;

	const { format } = new Intl.NumberFormat("en-GB", { style: "percent" });
	const value = storesPassedThreshold / totalStoresObserved;

	if (isNaN(value)) {
		return "0%";
	}

	const percentage = format(value);

	return percentage;
};

export default totalStoresPassedObservationThresholdPercentage;
